<template>
    <div v-if="show">    
        <teleport to="body">
            <div class="overlay" @click="toggleModale"></div>
            
            <div class="modale" :style="modaleWidth" style="min-width: 500px;">
                <div class="close" v-if="!hideCloser">
                    <span class="grow-effect" @click="toggleModale">X</span> 
                </div>

                <slot></slot>
            </div>
        </teleport>
    </div>
</template>

<script>
export default {
    props: ['show', 'width', 'hideCloser'],
    methods: {
        toggleModale() {
            this.$emit('toggle')
        }
    },
    computed: {
        modaleWidth() {
            if (this.width == undefined) {
                return 'width: 30%'
            } else {
                return 'width: ' + this.width
            }
        }
    }
}
</script>

<style scoped>
.overlay {
    z-index: 999;
    cursor: pointer;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(126, 125, 125, 0.5);
}
.modale {
    z-index: 1000;
    position: fixed;
    top: 110px;
    right: 0;
    left: 0;
    max-height: 80%;
    overflow-y: scroll;
    margin: auto;
    background-color: white;
    border-radius: 5px;
}
.close span {
    cursor: pointer;
    margin: 10px;
    padding: 10px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: lightgrey;
    border-radius: 5px;
}
.close span:hover {
    background-color: rgb(190, 1, 1);
    color: white;
}
</style>